import { EventEmitter, Injectable } from '@angular/core';
import {
  DOMAIN_VALIDATION_REGEX,
  EFAN_LENGTH,
  EMAIL_VALIDATION_REGEX,
  InputComponentWrapper,
  REMOVE_NON_NUMBERS_FROM_PHONE_NUMBER,
} from '../constants';
import { LocationDataType } from '../domain-objects/company/integration/epn-integration/location-data';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  DOMAIN_VALIDATION_REGEX;
  REMOVE_NON_NUMBERS_FROM_PHONE_NUMBER;
  EMAIL_VALIDATION_REGEX;
  EFAN_LENGTH;
  emailArrayEmitter: EventEmitter<InputComponentWrapper[]>;
  private validityMap: Map<string, boolean>;
  private emailArray: InputComponentWrapper[];

  constructor() {
    this.DOMAIN_VALIDATION_REGEX = DOMAIN_VALIDATION_REGEX;
    this.REMOVE_NON_NUMBERS_FROM_PHONE_NUMBER =
      REMOVE_NON_NUMBERS_FROM_PHONE_NUMBER;
    this.EMAIL_VALIDATION_REGEX = EMAIL_VALIDATION_REGEX;
    this.EFAN_LENGTH = EFAN_LENGTH;
    this.validityMap = new Map();
    this.emailArray = [];
    this.emailArrayEmitter = new EventEmitter<InputComponentWrapper[]>();
  }

  areAllEmailsValid(collection: string[]): boolean {
    let isValid = true;
    if (!collection) {
      return false;
    } else {
      for (const email of collection) {
        isValid = isValid && this.isEmailValid(email);
      }
      return isValid;
    }
  }

  isBasicInputValid(inputModel: string, isRequired = true): boolean {
    if (isRequired) {
      if (!inputModel) {
        return false;
      }
      return inputModel.length > 0;
    }
    return true;
  }

  setEmailArray(newEmailArray: InputComponentWrapper[]) {
    this.emailArray = [...newEmailArray];
    this.emailArrayEmitter.emit(this.emailArray);
  }

  isEmailBuilderValid() {
    for (const emails of this.emailArray) {
      if (!emails.isValid) {
        return false;
      }
    }
    return this.emailArray && this.emailArray.length > 0;
  }

  setValidityMap(map: Map<string, boolean>) {
    this.validityMap = map;
  }

  updateValidityMap(
    locationDataIndex: number,
    property: LocationDataType,
    value: boolean,
    innerArrayIndex?: number,
  ) {
    return this.validityMap.set(
      locationDataIndex + '' + property + innerArrayIndex,
      value,
    );
  }

  isLocationDataComponentValid(): boolean {
    let finalResult = true;
    this.validityMap.forEach((result) => {
      if (!result) {
        finalResult = false;
      }
    });
    return finalResult;
  }

  isEfanValid(inputModel: string, isRequired = false): boolean {
    if (!inputModel) {
      return !isRequired;
    }
    return (
      inputModel.length === this.EFAN_LENGTH &&
      !inputModel.includes('-') &&
      !inputModel.includes('.')
    );
  }

  isEncompassCompanyIdValid(inputModel: string, isRequired = false): boolean {
    if (!inputModel) {
      return !isRequired;
    }
    return inputModel.length <= 20;
  }

  isDomainInputValid(inputModel: string, isRequired = true): boolean {
    if (isRequired) {
      if (!inputModel) {
        return false;
      }
      return inputModel.match(this.DOMAIN_VALIDATION_REGEX) !== null;
    }
    return true;
  }

  isPhoneNumberValid(inputModel: string, isRequired = true): boolean {
    if (isRequired) {
      if (this.stripNonNumber(inputModel).length !== 10) {
        return false;
      }
    }
    return true;
  }

  isEmailValid(email: string, isRequired = true): boolean {
    if (isRequired) {
      if (!email) {
        return false;
      }
      const result = email.match(EMAIL_VALIDATION_REGEX) !== null; // redundant for easier testing
      return result;
    }
    return true;
  }

  stripNonNumber(phoneNumber: string): string {
    if (phoneNumber) {
      return phoneNumber.replace(this.REMOVE_NON_NUMBERS_FROM_PHONE_NUMBER, '');
    } else {
      return '';
    }
  }
}
